export const DEFAULT_SEVERITY_VECTOR = 'AV:_/AC:_/PR:_/UI:_/S:_/C:_/I:_/A:_';
